export default "__VITE_ASSET__b39f3dbb__"